<!-- 瀑布流商品 -->
<template>
  <div class="tabMenus" :style="{'margin-bottom': (data.marginBottom) / 16 + 'rem'}">
    <div class="title">{{ data.title }}</div>
    <div class="list">
      <div v-for="(item,index) in data.lists" :key="index" class="item" @click="handleClick(item,index)">
        <img :src="item.iconUrl">
        <p> <span v-if="item.tipText!==''" class="tips"> <span
              class="tips-text">{{ item.tipText }}</span></span>{{ item.firstClass }}</p>
        <div v-if="item.des.length>0" class="des">
          <div v-for="(it,ind) in item.des" :key="ind" class="des-item">
            {{ it.value }}
          </div>
        </div>
        <div class="price">
          ¥<span class="big">{{ item.price }}</span><span class="unit"><span class="unit-text">起</span></span>
        </div>
        <div v-if="item.discountTip.length>0" class="discount">
          <div v-for="(items,ind) in item.discountTip" :key="ind" class="discount-item"> <span>{{ items.value }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
  import clientUtil from '../common/clientUtil';
  import { sensorsBuriedPoint } from '../common/util';
  export default {
    name: "RecommendSetting",
    props: {
      data: {
        type: Object,
        default: () => { return {} }
      }
    },
    data() {
      return {
        vipEntrance: this.$route.query.from,
      }
    },
    methods: {
      handleClick(item, index) {
        const sensorObj = {
          LocationPage: `${this.$route.query.code}${document.title}`,
          EntryName: this.data.title,
          EntryRank: index + 1,
          RightName: item.productCode
        };
        sensorsBuriedPoint('MarketingPageClick', sensorObj)
        clientUtil.openNewWebPage({
          pageUrl: `flutter://economicalCard/rightsDetail?callback_origin=${this.vipEntrance}&firstClass=${item.firstClass}&equityType=1&product_code=${item.productCode}`,
        })
      }
    }
  }
</script>

<style lang="less" scoped>
  .tabMenus {
    width: 100%;
    box-sizing: border-box;
    padding: 20px 0px 0px;
    border-radius: 8px;
    position: relative;
  }
  .list {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
  .title {
    margin-bottom: 8px;
    color: #333333;
    font-weight: 500;
    font-size: 17px;
    font-family: PingFangSC-Semibold, PingFang SC;
  }
  .item {
    position: relative;
    margin-bottom: 8px;
    width: 48%;
    padding-bottom: 12px;
    overflow: hidden;
    background: #fff;
    border-radius: 4px;
    img {
      width: 100%;
      height: auto;
      display: block;
      border: 0;
      margin: 0 auto;
    }
    p {
      font-size: 13px;
      color: #2e2e33;
      margin: 10px 0 4px;
      padding: 0 12px;
      font-weight: 500;
      font-family: PingFangSC-Medium, PingFang SC;
      span {
        background: #ff3838;
        color: #fff;
        text-align: center;
        display: inline-block;
        padding: 0 2px;
        height: 16px;
        font-weight: 400;
        line-height: 18px;
        border-radius: 2px;
        margin-right: 6px;
        .tips-text {
          transform-origin: left;
          font-size: 12px;
          transform: scale(0.9);
          transform-origin: center;
          display: block;
          text-align: center;
          margin: 0 auto;
        }
      }
    }
    .des {
      padding: 0 12px;
      color: #aaaaaa;
      min-height: 16px;
      line-height: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      .des-item {
        font-size: 12px;
        transform: scale(0.916);
        padding-right: 5px;
        margin-right: 1px;
        position: relative;
        transform-origin: left top;
        display: inline-block;
        font-family: DINPro-Regular, DINPro;
        &:after {
          content: "";
          border-left: 1px solid #e2e2e2;
          position: absolute;
          right: -1px;
          top: 50%;
          transform: translateY(-50%);
          z-index: 1;
          width: 1px;
          height: 60%;
        }
        &:last-child {
          margin-right: 0;
          &:after {
            display: none;
          }
        }
      }
    }
    .price {
      margin-top: 2px;
      font-size: 13px;
      font-weight: 400;
      padding: 0 12px;
      color: #ff3838;
      font-family: "DINAlternate-Bold";
      .big {
        font-size: 19px;
        display: inline-block;
        margin: 0 1px;
        font-weight: bold;
        font-family: DINAlternate-Bold, DINAlternate;
        color: #ff3838;
      }
      .unit {
        display: inline-block;
        .unit-text {
          font-size: 12px;
          transform: scale(0.89);
          transform-origin: center top;
          display: block;
          margin: 0 auto;
          font-weight: 600;
        }
      }
    }
    .discount {
      padding: 0 12px;
      .discount-item {
        border: 1px solid rgba(255, 20, 45, 0.5);
        border-radius: 2px;
        padding: 0px 4px;
        text-align: center;
        color: #ff3838;
        margin-right: 4px;
        display: inline-block;
        line-height: 13px;

        &:last-child {
          margin-right: 0;
        }
        span {
          font-size: 10px;
          display: block;
          margin: 0 auto;
          font-weight: 400;
          font-family: DINPro-Regular, DINPro;
        }
      }
    }
  }
</style>
